import { useMemo } from 'react';
import { calculateSneakAttackDice } from '@character-creator/core';
import type { CharacterBenefits } from './useCharacterBenefits';

export interface SneakAttackFeature {
  available: boolean;
  dice: string; // e.g., "4d6"
  diceCount: number; // e.g., 4
}

export interface CombatFeatures {
  sneakAttack: SneakAttackFeature | null;
  // Future: rage, divineSmite, etc.
}

/**
 * Hook to detect available combat features based on character benefits
 */
export function useCombatFeatures(benefits: CharacterBenefits): CombatFeatures {
  return useMemo(() => {
    // Check for Rogue levels
    const rogueClass = benefits.classLevels.find(
      (cl) => cl.className.toLowerCase() === 'rogue'
    );

    const sneakAttack: SneakAttackFeature | null = rogueClass
      ? {
          available: true,
          ...calculateSneakAttackDice(rogueClass.level),
        }
      : null;

    return {
      sneakAttack,
    };
  }, [benefits.classLevels]);
}
